import styled from "@emotion/styled"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { Box } from "@rebass/grid/emotion"

export const CardWrapper = styled(Box)`
  .info-box {
    display: flex;
    flex-direction: column;
    @media (min-width: 1024px) {
      &.single-story {
        border: 1px solid ${theme.wild.color.nova.transparency.black[20]};
        border-left: none;
        justify-content: center;
      }
    }
    @media (min-width: 1280px) {
      &:not(.single-story) {
        border-radius: 4px;
        justify-content: center;
        .bottom-wrap {
          margin-top: auto;
        }
      }
    }
  }

  .quote-icon-box {
    svg {
      width: 22px;
      height: 15px;
      @media (min-width: ${theme.mediaqueries.large}) {
        width: 32px;
        height: 22px;
      }
      path {
        fill: ${theme.color.white};
      }
    }
  }
  .product-link {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;

    .taking-button {
      font-size: 12px !important;
      line-height: 15.6px !important;
      @media (min-width: ${theme.mediaqueries.medium}) {
        font-size: 14px !important;
        line-height: 18.2px !important;
      }
    }
  }
`

export const VideoContainer = styled(Box)`
  position: relative;
  video {
    cursor: pointer;
  }
  @media (min-width: ${theme.mediaqueries.large}) {
    video {
      border-radius: 4px;
      &.single-story-video {
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
      }
    }
  }
  .progressbar-wrapper {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    .duration-wrapper {
      width: 100%;

      .duration-bar {
        background: ${theme.wild.color.nova.transparency.black[40]};
        height: 4px;
        &-progress {
          background: ${theme.wild.color.nova.brand.accent[80]};
          height: 4px;
        }
        @media (min-width: ${theme.mediaqueries.small}) {
          height: 8px;
          &-progress {
            height: 8px;
          }
        }
        @media (min-width: ${theme.mediaqueries.large}) {
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          &-progress {
            border-bottom-left-radius: 4px;
          }
        }
      }
    }
  }
`

export const ButtonWrapper = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  .sound-mute-icon-button {
    margin-right: 8px;
    .sound-icon-container,
    .mute-icon-container {
      display: flex;
      width: 32px;
      height: 32px;
      background-color: ${theme.wild.color.nova.base.white};
      border-radius: 2px;
      align-items: center;
      justify-content: center;
      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
  .play-pause-icon-button {
    .play-icon-container,
    .pause-icon-container {
      display: flex;
      width: 32px;
      height: 32px;
      background-color: ${theme.wild.color.nova.base.black};
      border-radius: 2px;
      align-items: center;
      justify-content: center;
      svg {
        width: 16px;
        height: 16px;
      }
    }
    .play-icon-container {
      background-color: ${theme.wild.color.nova.brand.accent[80]};
      svg,
      path {
        fill: ${theme.wild.color.nova.base.black};
      }
    }
  }
`
